import axios from "axios";
import qs from 'qs';

const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
  paramsSerializer: {
    serialize: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
  }
});

// Attach token
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Attach logout-on-401 ONCE
let interceptorAttached = false;
export const attachAuthInterceptor = (logout) => {
  if (interceptorAttached) return;
  interceptorAttached = true;

  axiosInstance.interceptors.response.use(
    (res) => res,
    (error) => {
      if (error.response?.status === 401) {
        logout();
      }
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
// export const api = axios.create();
// const API_BASE_URL = process.env.REACT_APP_TRADEPLUS_URL;

// const axiosInstance = axios.create({
//     baseURL: API_BASE_URL,
//     headers: { 'Content-Type': 'application/json'},
// });


// // Automatically attach token if available
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = localStorage.getItem("accessToken"); // or sessionStorage
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Optional: handle global errors
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn("Unauthorized — maybe redirect to login?");
//       // e.g., window.location.href = "/login";
//     }
//     return Promise.reject(error);
//   }
// );



// export default axiosInstance;

// export const attachAuthInterceptor = (logout) => {
//   api.interceptors.response.use(
//     (res) => res,
//     (error) => {
//       if (error.response?.status === 401) {
//         logout();
//       }
//       return Promise.reject(error);
//     }
//   );
// };
